import React from "react";
import Innerhtml from "../utils/Innerhtml";
import WsrvImage from "../utils/WsrvImage";

export default function KeyFeatures({ data }) {
  return (
    <>
      <div className="keyfetures pt-16">
        <div className="container">
          <div className="text-center mb-4">
            {data?.subHeading && (
              <h2 className="text-4xl lg:text-[50px] font-[400] tracking-tight text-gray-800 mb-2">
                {data.subHeading}
              </h2>
            )}
            {data?.heading && (
              <h3 className="text-5xl lg:text-[68px] font-bold text-black pt-2">
                {data?.heading}
              </h3>
            )}
          </div>

          {data?.advanceData?.data?.length > 0 && (
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 pt-4">
              {data?.advanceData?.data.map((item, ind) => (
                <div key={ind}>
                  <div className="flex items-center space-x-4 p-4 ">
                    <WsrvImage
                      src={item.thumb}
                      alt={item.title || "feature"}
                      width={53}
                      height={58}
                      widths={[53, 106]}
                      className="w-[53px] h-[58px] object-contain"
                    />

                    <div>
                      <h2 className="lg:text-2xl text-lg  font-semibold text-gray-800">
                        {item.title}
                      </h2>
                      <div className="text-gray-600 lg:text-xl text-base mt-2">
                        <Innerhtml data={item.desci} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
